import React from 'react';
import { useMobile } from '../../../hook/usePlatform';
import ResponsivePaddingWrapper, {
  ResponsiveFlexDirection,
} from '../../../component/responsive/responsivePaddingWrapper';
import {
  FontWeightType,
} from '../../../component/Text';
import Counter from '../../../component/animation/animationCounter';
import { lineColor } from '../../../util/colors';

const MemberInfo: React.FC = () => {
  const isMobile = useMobile();
  const border = isMobile ? '' : `solid 1px ${lineColor}`;

  return (
    <ResponsivePaddingWrapper
      id="members"
      style={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        borderTop: border,
        paddingBlock: isMobile ? 40 : 160,
      }}
    >
      <div
        style={{
          paddingInline: 0,
          display: 'flex',
          alignItems: 'center',
          flexDirection: 'column',
        }}
      >
        <p
          style={{
            display: 'flex',
            fontFamily: 'NanumMyeongjo',
            fontSize: isMobile ? 20 : 40,
            height: 30,
            fontWeight: FontWeightType.w800,
          }}
        >
          현재&nbsp;
          <Counter
            style={{ textDecoration: 'underline', textDecorationThickness: 3 }}
            duration={4}
            format={(v) => `${v}`.replace(/(-?\d+)(\d{3})/, '$1,$2')}
            from={0}
            to={43912}
          />
          명의 회원님이
        </p>
        <p
          style={{
            display: 'flex',
            fontFamily: 'NanumMyeongjo',
            fontSize: isMobile ? 20 : 40,
            height: 16,
            fontWeight: FontWeightType.w800,
          }}
        >
          함께하고 있습니다
        </p>
        <p style={{ marginTop: isMobile ? 8 : 64, fontFamily: 'inter' }}>*시럽 앱 기준 데이터(2025년 3월)</p>
      </div>

      <ResponsiveFlexDirection style={{ gap: 16, marginTop: 32 }}>
        <div style={{ flex: 1 }}>

          <div
            style={{
              padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'center',
            }}
          >
            <img
              src="image/chartAge.png"
              alt=""
              width="100%"
            />
          </div>
        </div>
        <div style={{ flex: 1 }}>
          <div
            style={{
              padding: 32, display: 'flex', flexDirection: 'column', alignItems: 'center',
            }}
          >
            <img
              src="image/chartLocation.png"
              alt=""
              width="100%"
            />

          </div>
        </div>
      </ResponsiveFlexDirection>

    </ResponsivePaddingWrapper>
  );
};

export default MemberInfo;
